export const validatePhoneNumber = (phone) => {
    if (phone === "" || phone === null || phone === undefined) {
      return "ဖုန်းနံပါတ်ထည့်ရန်လိုအပ်ပါသည်။";
    }

    // Allow spaces/dashes while typing, then require strict 09 prefix.
    const cleanedPhone = phone.toString().replace(/[\s-]/g, "").replace(/\D/g, "");

    if (!cleanedPhone.startsWith("09") || cleanedPhone.length < 9 || cleanedPhone.length > 11) {
      return "09 ဖြင့်စပြီး ၉-၁၁ လုံးဖြစ်ရမည်";
    }

    return ""; // No error
  };  